import { fetchUserCheck } from './api-users.js';
import { oidcClient } from '../helpers/oidcClient.js';
import { setOidcUserStatus } from '../helpers/oidcUser.js';
import { hasValidSchweizmobilPlusRole, USER_ROLE, } from '../helpers/helper-users.js';
import { hasAuthCookie } from '../helpers/tokenOrCookie.js';
async function authFetchUsingToken(input, init, token) {
    if (!init.headers) {
        init.headers = {};
    }
    if (typeof init.headers !== 'object') {
        throw new Error('headers must be an object');
    }
    if (token?.length) {
        init.headers['Authorization'] = `Bearer ${token}`;
    }
    return fetch(input, init);
}
async function authFetchUsingCookie(input, init) {
    init.credentials = 'include';
    return fetch(input, init);
}
export async function authFetch(input, fetchWithoutValidRole = false, init) {
    let token;
    let parsedToken;
    if (hasAuthCookie()) {
        const result = await fetchUserCheck();
        if (result.loggedin) {
            parsedToken = {
                email: result.email,
                roles: [USER_ROLE.subscribedUser],
            };
        }
    }
    else {
        token = await oidcClient.getActiveToken();
        parsedToken =
            token !== ''
                ? oidcClient.parseJwtPayload(token)
                : undefined;
    }
    setOidcUserStatus(parsedToken);
    const hasValidRole = hasValidSchweizmobilPlusRole(parsedToken?.roles);
    if (!hasValidRole) {
        if (!fetchWithoutValidRole) {
            return undefined;
        }
        token = '';
    }
    if (!init) {
        init = {};
    }
    return hasAuthCookie()
        ? authFetchUsingCookie(input, init)
        : authFetchUsingToken(input, init, token);
}
export class HttpError extends Error {
    constructor(status, message) {
        super(message);
        this.status = status;
    }
}
export function failNotOK(r) {
    return r.then((p) => {
        if (p.ok) {
            return r;
        }
        console.log('KO', p.status, p.statusText, p.url);
        throw new HttpError(p.status, p.statusText);
    });
}
//# sourceMappingURL=api-helper.js.map